/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Paddle_NoteInputs */

const en_billing_paddle_note = /** @type {(inputs: Billing_Paddle_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD checkout is handled by Paddle (taxes included).`)
};

const id_billing_paddle_note = /** @type {(inputs: Billing_Paddle_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembayaran USD ditangani Paddle (sudah termasuk pajak).`)
};

/**
* | output |
* | --- |
* | "USD checkout is handled by Paddle (taxes included)." |
*
* @param {Billing_Paddle_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_paddle_note = /** @type {((inputs?: Billing_Paddle_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Paddle_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_paddle_note(inputs)
	return en_billing_paddle_note(inputs)
});